import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { UserModel } from "app/_models/user-model";
import { CommonservicesService } from "app/_services/commonservices.service";
import { CrudPurchaseOrderDetailsService } from "app/_services/MasterCrudOps/crud-purchase-order-details.service";
import { NotificationService } from "app/_services/notification.service";
import { SpreadsheetValidateService } from "app/_services/spreadsheetValidation.service";
import { SpreadsheetFileHandler } from "app/core/handlers/spreadsheet-file-handler";

@Component({
  selector: "app-bulk-upload-purchase-order-details",
  templateUrl: "./bulk-upload-purchase-order-details.component.html",
  styleUrls: ["../../../../../../bulk-style.css"],
})
export class BulkUploadPurchaseOrderDetailsComponent extends SpreadsheetFileHandler {
  currentUser: UserModel;
  isLoaderResult: boolean = false;
  file: File;
  uploadFileName: string;
  uploadFileContent: string;
  isAdminGroupUser: boolean = false;

  constructor(
    protected readonly datePipe: DatePipe,
    protected readonly spreadsheetService: SpreadsheetValidateService,
    protected readonly notify: NotificationService,
    private readonly crudPoDetailService:CrudPurchaseOrderDetailsService,
    private readonly commonService:CommonservicesService
  ) {
    super(spreadsheetService, datePipe, notify);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  downloadSampleFileForBulkPoDetails() {
    this.downloadFileHelper(
      this.crudPoDetailService.getSampleForBulkPoDetailsUpload(),
      "SampleBulkPurchaseOrderDetails"
    );  
  }

  onPurchaseOrderDetailsFileUpload(event: any) {
    this.handleFileUpload(
      event,
      (file) => this.uploadToAPI(file),
      "upload_bulkPoDetails"
    );
  }

  
     uploadToAPI(file: File)
  {
     this.uploadFileHelper(
      (formData) =>
        this.crudPoDetailService.uploadFileForBulkPoDetails(formData),
      file,
      (fileName) => this.downloadResultFile(fileName)
    );
  }

    downloadResultFile(fileName: string): void {
      this.downloadResultFileHelper(
      this.commonService.getResultFileByFileName(fileName),
      fileName,
      "Bulk purchase order detail result file download process started.",
      "Error in downloading the bulk purchase order detail file"
    );
   }
    
    
}
